<div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">
    <div>
           <div [@.disabled]="disableAnimation()">
        <mat-accordion multi="false">

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RoadAndPath"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg1_250k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.RoadAndPath"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Railway"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg2_250k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Railway"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Groundcover"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg3_250k_{{translateService.currentLang.slice(0, -1)}}.png"  alt='{{"legend.Groundcover"|translate}}' >
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"Relief"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg4_250k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"Relief"|translate}}' >
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Hydrography"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg5_250k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Hydrography"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.SpecificElements"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg6_250k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.SpecificElements"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.AdministrativeData"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img250k/leg7_250k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.AdministrativeData"|translate}}'>
                </div>
            </mat-expansion-panel>

        </mat-accordion>
    </div>
</div>